import { render, staticRenderFns } from "./statusesList.vue?vue&type=template&id=3967ce5e&scoped=true&"
import script from "./statusesList.vue?vue&type=script&lang=js&"
export * from "./statusesList.vue?vue&type=script&lang=js&"
import style0 from "./statusesList.vue?vue&type=style&index=0&id=3967ce5e&lang=scss&scoped=true&"
import style1 from "./statusesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967ce5e",
  null
  
)

export default component.exports